import { Divider } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { scrollToTop } from "apps/commons/functions/scrollToTop";
import { photosBinder } from "libs/analytics/binders/onboarding/photos";
import { useAnalytics } from "libs/analytics/useAnalytics";
import { Fragment, useEffect } from "react";
import { Title } from "../Title";
import { AccommodationCategoryEnum } from "../constants/accommodationCategoryEnum.ts";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useAccommodationCategory } from "../useAccommodationCategory.ts";
import { EligibleOnly } from "./EligibleOnly";
import { PropertyPhotosController } from "./PropertyPhotosController.tsx";
import { RoomPhotosController } from "./RoomPhotosController.tsx";
import { Tips } from "./Tips";

export const PhotoPage = () => {
    const {
        cmsData: {
            photo: { photos },
        },
    } = useStaticDataAtomValue();
    const { hasAccommodationTypes } = useAccommodationCategory();

    useEffect(() => {
        scrollToTop();
    }, []);

    useAnalytics(photosBinder);

    const isHotel = hasAccommodationTypes(AccommodationCategoryEnum.Hotel, AccommodationCategoryEnum.MultipleNha);

    return (
        <VStack gap="24" pb="32">
            <Title title={photos} />
            <EligibleOnly />
            <PropertyPhotosController />
            <Tips />
            {isHotel && (
                <Fragment>
                    <Divider />
                    <RoomPhotosController />
                </Fragment>
            )}
        </VStack>
    );
};
